import React, { useState } from 'react';
import { User, Bot, ChevronDown, ChevronUp, FileText, Database } from 'lucide-react';
import type { Message } from '../../types/agent';

interface ChatMessageProps {
  message: Message;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const [showSources, setShowSources] = useState(false);
  const isUser = message.role === 'user';
  const sources = message.metadata?.sources || [];

  return (
    <div className={`flex gap-3 ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      {!isUser && (
        <div className="flex-shrink-0">
          <div className="w-8 h-8 rounded-full bg-indigo-600 flex items-center justify-center">
            <Bot className="w-5 h-5 text-white" />
          </div>
        </div>
      )}

      <div className={`flex flex-col ${isUser ? 'items-end' : 'items-start'} max-w-[70%]`}>
        <div
          className={`px-4 py-2 rounded-lg ${
            isUser
              ? 'bg-indigo-600 text-white'
              : 'bg-gray-100 text-gray-900'
          }`}
        >
          <p className="whitespace-pre-wrap">{message.content}</p>
        </div>

        {/* Sources */}
        {!isUser && sources.length > 0 && (
          <div className="mt-2 w-full">
            <button
              onClick={() => setShowSources(!showSources)}
              className="text-sm text-gray-600 hover:text-gray-800 flex items-center gap-1"
            >
              {showSources ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
              Fonti ({sources.length})
            </button>

            {showSources && (
              <div className="mt-2 space-y-2">
                {sources.map((source, index) => (
                  <div key={index} className="text-sm bg-white border border-gray-200 rounded p-2">
                    <div className="flex items-center gap-2 font-medium text-gray-700 mb-1">
                      {source.type === 'pdf' ? (
                        <FileText className="w-4 h-4" />
                      ) : (
                        <Database className="w-4 h-4" />
                      )}
                      {source.document && (
                        <span>
                          {source.document}
                          {source.page && ` - Pag. ${source.page}`}
                        </span>
                      )}
                    </div>
                    {source.excerpt && (
                      <p className="text-gray-600 text-xs italic">"{source.excerpt}"</p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <span className="text-xs text-gray-500 mt-1">
          {new Date(message.createdAt).toLocaleTimeString('it-IT', {
            hour: '2-digit',
            minute: '2-digit'
          })}
        </span>
      </div>

      {isUser && (
        <div className="flex-shrink-0">
          <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center">
            <User className="w-5 h-5 text-gray-700" />
          </div>
        </div>
      )}
    </div>
  );
};
